module.exports = __webpack_public_path__ + "static/media/mailstorm.640496f9.jpeg";